import React from "react";

export default function airBnb(scope: any) {
  return process.env.REACT_APP_ENV === "PROD"
    ? `https://www.airbnb.com/oauth2/auth?client_id=4kk6ii3r86yqk42je6o8bdker&redirect_uri=https://extranetv4.bookingjini.com/airbnb-code/&scope=${scope},messages_read,messages_write&state=`
    : "https://www.airbnb.com/oauth2/auth?client_id=28nb6aej5cji9vsnqbh22di8y&redirect_uri=https://extranet-build.vercel.app/airbnb-code/&scope=property_management,messages_read&state=";
}
